import {ICustomer} from "./customer.model";
import {IOrganization} from "./organization.model";
import {IEmployee} from "./employee.model";
import {IProject} from "./project.model";
import {ISupplier} from "./supplier.model";
import {IInstaller} from "./installer.model";
import {IFactor} from "./factor.model";
import {IOrder} from "./order.model";

export interface IIncoming {
  id?: number;
  itemName?: string;
  status?: string;
  code?: string;
  amount?: string;
  employee_str?: any;
  supplier_str?: any;
  installer_str?: any;
  factor_str?: any;
  project_str?: any;
  order_str?: any;
  bank?: string;
  title?: string;
  type?: string;
  form_type?: string;
  receiver?: string;
  receiver_account?: string;
  check_number?: string;
  date?: any;
  description?: string;
  paid?: any;
  spent_to?: string;
  customer?: ICustomer;
  employee?: IEmployee;
  project?: IProject;
  supplier?: ISupplier;
  installer?: IInstaller;
  factor?: IFactor;
  order?: IOrder;
  organization?: IOrganization;
  createdBy?: string;
  createdDate?: any;
  jalaliDate?: string;
  jalaliDate_reminder?: string;

}

export class Incoming implements IIncoming {
  constructor(public id?: number, public itemName?: string, public status?: string,
              public type?: string,
              public title?: string,
              public unit?: string,
              public code?: string,
              public cost?: string,
              public paid?: string,
              public description?: string) {
  }
}
